var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mall-postcode-layer"},[_c('MallHeader',{attrs:{"title":'주소 검색'},on:{"back-click":function($event){return _vm.$emit('close')}}},[_c('div',{staticClass:"mall-postcode-layer__header-space",attrs:{"slot":"right"},slot:"right"})]),_vm._v(" "),_c('div',{ref:"embed",staticClass:"mall-postcode-layer__embed"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-080f13a9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/new/organisms/MallPostcodeLayer.vue
// module id = null
// module chunks = 